export default import.meta.ROLLDOWN_FILE_URL_bUHOmgj0v0e8gORvphau3Q